var React = require('react');

function MoonInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("linearGradient",{"id":"linear-gradient","x1":"1142.5","x2":"1142.5","y2":"180","gradientUnits":"userSpaceOnUse","key":0},[React.createElement("stop",{"offset":"0","stopColor":"#fff","stopOpacity":".4","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#fff","stopOpacity":"0","key":1})]),React.createElement("clipPath",{"id":"clip-path","transform":"translate(719.4 -128.5)","key":1},React.createElement("path",{"className":"cls-1","d":"M3.4 0h1119v512H3.4z"}))]),React.createElement("g",{"clipPath":"url(#clip-path)","id":"GRADIENT_OVERLAY_copy_2","data-name":"GRADIENT OVERLAY copy 2","key":1},React.createElement("circle",{"cx":"1142.5","cy":"90","r":"90","fill":"url(#linear-gradient)"}))]);
}

MoonInline.defaultProps = {"viewBox":"725 0 1115 371"};

module.exports = MoonInline;

MoonInline.default = MoonInline;
